@if(loggedIn) {
<app-master></app-master>
}
@else {
<app-login></app-login>
}

<mat-spinner id="spinner"></mat-spinner>
<div id="spinner-overlay">
</div>